<template>
  <div class="container-fluid m-0 p-0">
    <router-view></router-view>
    <LoadingView v-if="$store.state.isLoading" />
  </div>
</template>

<script>
import LoadingView from '@/components/layouts/Loading'
import $ from 'jquery'

export default {
  name: 'app',
  components: {
    LoadingView
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      // this.$store.state.screenHeight = window.innerHeight
    }
  },
  mounted () {
    window.addEventListener('popstate', () => {
      $('body').removeClass('theme-light')
      $('body').removeClass('modal-open')
      $('div').removeClass('modal-backdrop')
    })
  }
}
</script>

<style>
body,
html,
.theme-light {
  background-color: #805f41 !important;
  padding: 0px;
  margin: 0px;
  font-family: "Mitr", sans-serif;
  overflow: hidden !important;
}

h1 {
  margin-top: 0px;
  font-family: "Mitr", sans-serif;
}

span,
a {
  font-family: "Mitr", sans-serif;
}

a:link {
  text-decoration: none !important;
}

a:visited {
  text-decoration: none !important;
}

a:hover {
  text-decoration: none !important;
}

a:active {
  text-decoration: none !important;
}

.swal2-title,
.swal2-html-container,
.text-body,
.text-muted,
.form-control {
  font-family: "Mitr", sans-serif;
}

.bg-rmutl {
  background: #74573c !important;
}

.bg-content-se {
  position: absolute !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  width: 100% !important;
  height: 82vh !important;
  left: 0px !important;
  top: 120px !important;
  background: #ffffff !important;
  border-radius: 0px 50px 0px 0px !important;
  padding: 5px 5px 0px 5px;
}

.bg-content-4 {
  position: absolute !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  width: 100% !important;
  height: 80vh !important;
  left: 0px !important;
  top: 120px !important;
  background: #ffffff !important;
  border-radius: 0px 50px 0px 0px !important;
  padding: 5px 5px 0px 5px;
}

.bg-content {
  position: absolute !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  width: 100% !important;
  height: 87vh !important;
  left: 0px !important;
  top: 120px !important;
  background: #ffffff !important;
  border-radius: 0px 50px 0px 0px !important;
  padding: 5px;
}

.footerbar {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue